import React from 'react'
import Toggle from '../../pb_toggle/_toggle'

const ToggleDefault = () => {
  return (
    <>
      <Toggle
          checked
      />

      <br />

      <Toggle />
    </>
  )
}

export default ToggleDefault
